import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl
} from "@mui/material";
import { format } from "date-fns";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const PROCEDURES = [
  { key: "meetingHierarchy", name: "Иерархия встреч" },
  { key: "arbitration", name: "Ин-нет, арбитраж" },
  { key: "businessInspection", name: "Осмотр бизнеса" },
  { key: "expressAudit", name: "Экспресс-аудит" },
  { key: "sB1", name: "СБ-1" },
  { key: "sB2", name: "СБ-2" },
];

const SELECTOR_OPTIONS = [
  "проводился, негатива нет",
  "проводился, негатив есть",
  "не проводился"
];

const ProceduresTable = ({ data, onChange }) => {
  const handleCellChange = (procedureKey, field, value) => {
    const updatedData = {
      ...data,
      [procedureKey]: {
        ...(data?.[procedureKey] || {}),
        [field]: value
      }
    };
    onChange(updatedData);
  };

  const formatDateForInput = (dateValue) => {
    if (!dateValue) return "";
    try {
      const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
      return format(date, "yyyy-MM");
    } catch (e) {
      return "";
    }
  };

  const handleDateChange = (procedureKey, value) => {
    if (value) {
      const date = new Date(value);
      handleCellChange(procedureKey, 'date', date.toISOString());
    } else {
      handleCellChange(procedureKey, 'date', null);
    }
  };

  const columns = [
    { label: "Процедуры", minWidth: 200 },
    { label: "Статус", minWidth: 250 },
    { label: "Результат, исп-тель", minWidth: 300 },
    { label: "Когда", minWidth: 150 },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={sdmTableStyles.sectionTitle}>
          Процедуры:
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: "16px" }}>
        <Box sx={{ flex: 1 }}>
          <TableContainer
            component={Paper}
            elevation={0}
            sx={sdmTableStyles.tableContainer}
          >
            <Table size={sdmTableStyles.tableSize}>
              <TableHead>
                <TableRow sx={sdmTableStyles.headerRow}>
                  {columns.map((headCell, index) => (
                    <TableCell
                      key={index}
                      sx={getHeaderCellStyle(headCell.minWidth)}
                    >
                      {headCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {PROCEDURES.map((procedure) => {
                  const procData = data?.[procedure.key] || {};
                  return (
                    <TableRow key={procedure.key} sx={sdmTableStyles.dataRow}>
                      <TableCell sx={{ ...sdmTableStyles.dataCell, fontSize: "13px", color: "#111827" }}>
                        {procedure.name}
                      </TableCell>
                      <TableCell sx={sdmTableStyles.dataCell}>
                        <FormControl size="small" fullWidth>
                          <Select
                            value={procData.selector || ""}
                            onChange={(e) => handleCellChange(procedure.key, 'selector', e.target.value)}
                            displayEmpty
                            sx={sdmTableStyles.selectField}
                          >
                            <MenuItem value="">
                              <em>Не выбрано</em>
                            </MenuItem>
                            {SELECTOR_OPTIONS.map((option, index) => (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell sx={sdmTableStyles.dataCell}>
                        <TextField
                          value={procData.result || ""}
                          onChange={(e) => handleCellChange(procedure.key, 'result', e.target.value)}
                          variant="outlined"
                          size="small"
                          fullWidth
                          sx={sdmTableStyles.textField}
                        />
                      </TableCell>
                      <TableCell sx={sdmTableStyles.dataCell}>
                        <TextField
                          type="month"
                          value={formatDateForInput(procData.date)}
                          onChange={(e) => handleDateChange(procedure.key, e.target.value)}
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                          sx={sdmTableStyles.textField}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Right Side Comments Field */}
        <Box sx={{ flex: "0 0 300px", display: "flex", flexDirection: "column" }}>
          <Box sx={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#64748B",
            marginBottom: "8px",
            padding: "16px 16px 0 16px",
            textTransform: "uppercase"
          }}>
            Комментарии по процедурам
          </Box>
          <Box sx={{ flex: 1, padding: "0 16px 16px 16px" }}>
            <TextField
              value={data?.proceduresComment || ""}
              onChange={(e) => {
                const updatedData = {
                  ...data,
                  proceduresComment: e.target.value
                };
                onChange(updatedData);
              }}
              multiline
              fullWidth
              variant="outlined"
              size="small"
              sx={{
                height: "100%",
                "& .MuiOutlinedInput-root": {
                  height: "100%",
                  alignItems: "flex-start",
                  paddingTop: "8px"
                },
                "& .MuiOutlinedInput-input": {
                  height: "100%",
                  resize: "none",
                  fontFamily: "inherit"
                }
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProceduresTable;
